import { render, staticRenderFns } from "./addRelevance.vue?vue&type=template&id=d8b92e62&scoped=true&"
import script from "./addRelevance.vue?vue&type=script&lang=js&"
export * from "./addRelevance.vue?vue&type=script&lang=js&"
import style0 from "./addRelevance.vue?vue&type=style&index=0&id=d8b92e62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b92e62",
  null
  
)

export default component.exports